<template>
    <lateral-content
        :isLoading="isLoading"
        v-model="showFilterInner"
        header
        :title="idToEdit == null ? $t('criar-novo-acesso-cliente') : $t('editar-acesso-cliente')"
        footer
        compact
    >
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
        <div class="bg p-3 pb-6" v-if="showFilterInner">
            <div class="form-columns-fit mb-4">
                <div class="columns is-flex-wrap">
                    <div class="column is-12">
                        <vss-select
                            title="empresa"
                            ref="empresaSelect"
                            v-model="empresaSelected"
                            :options="empresaList"
                            :loading="empresaLoading"
                            @search="carregarEmpresas"
                            label="nome"
                            searchable
                            :invalid="isNull(empresaSelected)"
                            required
                            :disabled="isLoading || idToEdit != null"
                        />
                    </div>
                    <div class="column is-12">
                        <vss-select
                            title="cliente"
                            ref="clienteSelect"
                            v-model="clienteSelected"
                            :options="clienteList"
                            :loading="clienteLoading"
                            @search="carregarClientes"
                            label="nome"
                            searchable
                            :invalid="isNull(clienteSelected)"
                            required
                            :disabled="isLoading || idToEdit != null"
                        />
                    </div>
                    <div class="column is-12">
                        <v-input
                            ref="nomeInput"
                            v-model="acessoCliente.nome"
                            placeholder="placeholder-preencha"
                            title="nome"
                            tooltipLabel="tooltip-acesso-cliente-nome"
                            tooltipSize="is-small"
                            tooltipPosition="is-left"
                            :invalid="isNull(acessoCliente.nome)"
                            required
                            :disabled="isLoading"
                            :maxlength="100"
                            :uppercase="false"
                        />
                    </div>
                    <div class="column is-12">
                        <v-input
                            ref="emailInput"
                            v-model="acessoCliente.email"
                            placeholder="placeholder-preencha"
                            title="email"
                            tooltipLabel="tooltip-acesso-cliente-email"
                            tooltipSize="is-small"
                            :maxlength="100"
                            :msg="invalidEmailMsg"
                            :invalid="invalidEmail"
                            :onBlurFunction="validateEmailInner"
                            :disabled="isLoading"
                            required
                            :uppercase="false"
                        />
                    </div>
                    <div class="column is-12">
                        <v-input
                            ref="chaveInput"
                            v-model="acessoCliente.chave"
                            placeholder="placeholder-preencha"
                            title="chave"
                            tooltipLabel= "tooltip-acesso-cliente-chave" 
                            tooltipSize="is-small"
                            tooltipPosition="is-left"
                            :invalid="isNull(acessoCliente.chave)"
                            required
                            :maxlength="40"
                            :uppercase="false"
                        />
                    </div>
                    <div class="column is-12">
                        <vss-select
                            title="situacao"
                            v-model="situacaoSelected"
                            mlLabels
                            :options="situacaoList"
                            :invalid="isNull(situacaoSelected)"
                            required
                            :disabled="isLoading"
                        />
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:footer-right="{ id }">
            <b-button type="is-primary" @click="save()" :disabled="!permissao.create">
                {{ $t('salvar') }}
            </b-button>
        </template>
    </lateral-content>
</template>

<script>
import AcessoClienteValidation from '@/services/validations/promotor/portal-do-cliente/PortalDoClienteUserValidation.js';

export default {
    components: {},
    props: {
        showFilter: {
            type: Boolean,
            default: false,
        },
        idToEdit: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            validation: new AcessoClienteValidation(),
            showFilterInner: false,
            empresaList: [],
            empresaSelected: null,
            empresaLoading: true,
            clienteList: [],
            clienteSelected: null,
            clienteLoading: true,

            situacaoList: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            situacaoSelected: { label: 'ativo', id: 1 },
            acessoClienteBase: null,
            acessoCliente: {
                idacs_cliente_cliente: null,
                idempresa: null,
                idcliente: null,
                nome: null,
                email: null,
                chave: null,
                situacao: null,
                modulo: 'p',
            },

            isLoading: false,
            permissao: null,

            invalidEmailMsg: 'msg-campo-obrigatorio',
            invalidEmail: false,
        };
    },
    watch: {
        showFilter(val) {
            if (val != this.showFilterInner) this.showFilterInner = val;
        },
        showFilterInner(val) {
            if (val != this.showFilter) this.$emit('close');
        },
        idToEdit(val) {
            this.acessoCliente = { ...this.acessoClienteBase };
            if (val != null) {
                this.carregarDados();
            }
        },
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'promotor',
            'portal-do-cliente',
            'portal-do-cliente'
        );
        this.acessoClienteBase = { ...this.acessoCliente };

        this.carregarEmpresas();
        this.carregarClientes();
    },
    methods: {
        carregarDados() {
            this.isLoading = true;
            this.$axios
                .get(`/acessoCliente/full/${this.idToEdit}`)
                .then((response) => {
                    if (this.isNull(response.data.content)) {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    } else {
                        this.acessoCliente = Object.assign(response.data.content);
                        this.empresaSelected = {
                            idempresa: this.acessoCliente.idempresa,
                            nome: this.acessoCliente.empresaNome,
                            rsocial: this.acessoCliente.empresaRsocial,
                            id: this.acessoCliente.idempresa,
                        };
                        this.clienteSelected = {
                            idcliente: this.acessoCliente.idcliente,
                            nome: this.acessoCliente.clienteNome,
                            rsocial: this.acessoCliente.clienteRsocial,
                            id: this.acessoCliente.idcliente,
                        };
                        this.situacaoSelected = this.situacaoList.find(f => f.id == this.acessoCliente.situacao);
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        validateEmailInner() {
            if (this.isNull(this.acessoCliente.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-obrigatorio';
            } else if (!this.validateEmail(this.acessoCliente.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-invalido';
            } else {
                this.invalidEmail = false;
            }
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    this.empresaList = Object.assign(response.data.content);
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.empresaLoading = false;
                });
        },
        carregarClientes(search = '.*') {
            this.clienteLoading = true;
            this.$axios
                .get('/promotor/cliente/getcombo.json', {
                    params: {
                        param: search,
                        situacao: 1,
                    },
                })
                .then((response) => {
                    this.clienteList = Object.assign(response.data.content);
                })
                .catch((e) => {
                    this.clienteList = [];
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            this.acessoCliente.idempresa =
                this.empresaSelected != null ? this.empresaSelected.id : null;
            this.acessoCliente.idcliente =
                this.clienteSelected != null ? this.clienteSelected.id : null;
            this.acessoCliente.situacao = this.situacaoSelected.id;

            this.validateEmailInner();

            if (this.validation.validate(this.acessoCliente, this.idToEdit, this.$refs)) {
                this.$axios
                    .post(`/acessoCliente`, this.acessoCliente)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$root.showMessage('success', 'msg-acesso-cliente-salvo');
                            this.$emit('atualizar');
                            this.$emit('close');
                        }
                    })
                    .catch((e) => {
                        if (e.data && this.$te(e.data.message)) {
                            this.$root.showMessage('error', this.$t(e.data.message));
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        }
                    })
                    .finally((_) => {
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
            }
        },
    },
};
</script>
